import { render, staticRenderFns } from "./PaymentContractsTab.vue?vue&type=template&id=27b2ddc9&"
import script from "./PaymentContractsTab.vue?vue&type=script&lang=js&"
export * from "./PaymentContractsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports